export { SoccerFixture } from './SoccerFixture'
export { SoccerContestant } from './SoccerContestant'
